module.exports = __webpack_public_path__ + "fonts/iconfont.256f18bf.woff";